import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository'
import type { DashboardClassroomDiagnosticState } from '@/core/domain/dashboard/DashboardClassroomDiagnosticState'

/**
 * Use case pour récupérer l'état des diagnostics d'une classe
 */
export class FetchClassroomDiagnosticStateUseCase {
  private readonly dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(classroomId: number): Promise<DashboardClassroomDiagnosticState> {
    return await this.dashboardRepository.fetchDashboardClassroomDiagnosticState(classroomId)
  }
}
